import { render, staticRenderFns } from "./PrivacyModal.vue?vue&type=template&id=e2676f3a&scoped=true"
import script from "./PrivacyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyModal.vue?vue&type=style&index=0&id=e2676f3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2676f3a",
  null
  
)

export default component.exports